import './index.scss';
import { Classes, } from 'src/assets/icon';
import { AppSpan, AppText, FlexColumn, FlexRow, RoundImageContainer } from 'src/style';
import ImageFallback from "src/assets/img/image-fallback.png";
import { UsersCardProps } from '../types';

export const UsersCard = ({ title, list, className }: UsersCardProps) => {
    const count = list?.length;
    const isNotClassList = title !== 'Classes'

    return (
        <FlexColumn
            justifyContent='start'
            className={`card-list-wrapper ${className}`}
        >
            <FlexRow
                topPadding='1.5'
                bottomPadding='1.5'
                leftPadding='3'
                rightPadding='3'
                justifyContent='space-between'
                className='list-card-header'
            >
                <AppText fontWeight='600' color='#712126'>{title}</AppText>
                <AppText fontWeight='600' color='#712126'>{count}</AppText>
            </FlexRow>
            {
                list?.map((user: any, i: number) => (
                    <FlexRow
                        key={i}
                        leftPadding='3'
                        rightPadding='3'
                        bottomMargin='2'
                        gap='1'
                        justifyContent='left'
                        className='list-item'
                    >
                        <RoundImageContainer className='list-image' size='4' isMaxWidth>
                            {isNotClassList ?
                                (<img className='' src={user?.avater ?? ImageFallback} alt='user avatar' />) :
                                <Classes />
                            }
                        </RoundImageContainer>
                        <AppText
                            className='line-item-text'
                            textSize='1.2'
                            fontWeight='500'
                            color={isNotClassList ? '#712126' : '#374957'}
                        >
                            {isNotClassList ? `${user?.surname} ${user?.firstName}` : `${user}`}
                            {
                                isNotClassList ?
                                    (<AppSpan
                                        textSize='1.2'
                                        leftMargin='.5'
                                        fontWeight='500'
                                        color='#374957'
                                    >
                                        {user?.memberClass}
                                    </AppSpan>) : null
                            }
                        </AppText>
                    </FlexRow>
                ))
            }
        </FlexColumn>
    )
}
